import { useSetAtom } from 'jotai';

import { preSessionVibesOpenAtom, visitorDrawerStateAtom } from '../../state';
import { useBackgroundMusicPlayback } from '../background-action/useBackgroundMusicPlayback';
import { VibesCta } from './VibesCta';

export function VibesCtaWrapper() {
  const setPreSessionVibesOpen = useSetAtom(preSessionVibesOpenAtom);
  const setDrawerState = useSetAtom(visitorDrawerStateAtom);
  const { handlePlay } = useBackgroundMusicPlayback();
  const openPreSessionVibes = () => {
    setDrawerState(null);
    setPreSessionVibesOpen(true);
    handlePlay();
  };

  return <VibesCta openPreSessionVibes={openPreSessionVibes} />;
}
